import { OrganizationJobPosition } from '@/shared/api/protocol-ts/model/dto_organization_job_position_pb';
import { OrganizationStaffRoleType } from '@/shared/api/protocol-ts/model/dto_organization_staff_pb';

import { PermissionStatuses } from './i18n';

export type PermissionType =
  | 'Full Access'
  | 'Clinical Access'
  | 'Limited Clinical Access'
  | 'Non-clinical Member';

export const TREATING_DOCTORS_AVAILABLE_ROLES = [
  OrganizationStaffRoleType.OrganizationStaffRoleType_LimitedClinicalAccess,
  OrganizationStaffRoleType.OrganizationStaffRoleType_ClinicalAccess,
  OrganizationStaffRoleType.OrganizationStaffRoleType_FullAccess,
];

export const NON_DENTAL_POSITIONS: readonly OrganizationJobPosition[] = [
  OrganizationJobPosition.OrganizationJobPositionAllergistImmunologist,
  OrganizationJobPosition.OrganizationJobPositionAnesthesiologist,
  OrganizationJobPosition.OrganizationJobPositionCardiologist,
  OrganizationJobPosition.OrganizationJobPositionDermatologist,
  OrganizationJobPosition.OrganizationJobPositionEmergencyPhysician,
  OrganizationJobPosition.OrganizationJobPositionEndocrinologist,
  OrganizationJobPosition.OrganizationJobPositionGastroenterologist,
  OrganizationJobPosition.OrganizationJobPositionGeneralPractitioner,
  OrganizationJobPosition.OrganizationJobPositionGeneralSurgeon,
  OrganizationJobPosition.OrganizationJobPositionGeriatrician,
  OrganizationJobPosition.OrganizationJobPositionHematologist,
  OrganizationJobPosition.OrganizationJobPositionInfectiousDiseaseSpecialist,
  OrganizationJobPosition.OrganizationJobPositionInternist,
  OrganizationJobPosition.OrganizationJobPositionNeonatologist,
  OrganizationJobPosition.OrganizationJobPositionNephrologist,
  OrganizationJobPosition.OrganizationJobPositionNeurologist,
  OrganizationJobPosition.OrganizationJobPositionNeurosurgeon,
  OrganizationJobPosition.OrganizationJobPositionObstetricianGynecologist,
  OrganizationJobPosition.OrganizationJobPositionOncologist,
  OrganizationJobPosition.OrganizationJobPositionOphthalmologist,
  OrganizationJobPosition.OrganizationJobPositionOrthopedicSurgeon,
  OrganizationJobPosition.OrganizationJobPositionOtolaryngologist,
  OrganizationJobPosition.OrganizationJobPositionPediatrician,
  OrganizationJobPosition.OrganizationJobPositionPhysiatrist,
  OrganizationJobPosition.OrganizationJobPositionPlasticSurgeon,
  OrganizationJobPosition.OrganizationJobPositionPsychiatrist,
  OrganizationJobPosition.OrganizationJobPositionPulmonologist,
  OrganizationJobPosition.OrganizationJobPositionRadiologist,
  OrganizationJobPosition.OrganizationJobPositionRheumatologist,
  OrganizationJobPosition.OrganizationJobPositionUrologist,
];

export const STORAGE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;
export const BYTES_IN_KB = 1024;
export const BYTES_PER_GB = BigInt(BYTES_IN_KB * BYTES_IN_KB * BYTES_IN_KB);
export const BASE_STORAGE_LIMIT = BYTES_PER_GB * BigInt(BYTES_IN_KB); // 1 TB

export const STORAGE_WARNING_THRESHOLD = 80;
export const STORAGE_FULL_THRESHOLD = 100;

export const PERMISSIONS: Record<PermissionType, PermissionStatuses[]> = {
  'Full Access': [
    PermissionStatuses['Manage payments and subscriptions'],
    PermissionStatuses['Manage company settings'],
    PermissionStatuses['View and manage staff'],
    PermissionStatuses['Share patients'],
    PermissionStatuses["Manage patient's reports"],
    PermissionStatuses['View and manage patients'],
  ],
  'Clinical Access': [
    PermissionStatuses['Share patients'],
    PermissionStatuses['View and manage staff'],
    PermissionStatuses["Manage patient's reports"],
    PermissionStatuses['View and manage patients'],
  ],
  'Limited Clinical Access': [
    PermissionStatuses['Share patients'],
    PermissionStatuses["Manage patient's reports"],
    PermissionStatuses['View and manage patients'],
  ],
  'Non-clinical Member': [PermissionStatuses['View and manage patients']],
};
